import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProcessFlatNode} from "../../../../../classes/process-flat-node";
import {UploadComponent} from "../../../../../modules/upload/upload.component";
import {FileImportTO} from "../../../../../classes/file-import-to";
import {FormTO} from "../../../../../classes/form-to";
import {ProcessBuilderService} from "../../../../../services/process-builder.service";
import {MatDialog} from "@angular/material/dialog";
import {TransformUntilMe} from "../../../../../classes/transform-until-me";

@Component({
  selector: 'sprout-designer-html2pdf',
  templateUrl: './html2-pdf.component.html',
  styleUrls: ['./html2-pdf.component.css']
})
export class Html2PDFComponent implements OnInit {

  @Input()
  processNode: ProcessFlatNode;

  public form: FormTO;
  pdfSrc: any;
  data: any;
  pdfBackgroundColor = "#efefef";

  constructor(private processBuilderService: ProcessBuilderService) {

    this.form = processBuilderService.form;

    if (this.processNode) {
      processBuilderService.processNode = this.processNode;
    } else {
      this.processNode = processBuilderService.processNode;
    }

    this.processNode.formId = this.form.id;

  }

  ngOnInit(): void {

    const transformUntilMe = new TransformUntilMe();
    transformUntilMe.process = this.processNode;
    // transformUntilMe.input = this.formValue;
    transformUntilMe.inputContentType = 'text/html';

    this.processBuilderService.processUntilMe(transformUntilMe).subscribe(response => {
      // console.log('processUntilMe.response:');
      // console.dir(response);
      // console.debug(response.output);
      // const blob = new Blob([atob(response.output)], { type: 'application/pdf' });
      // console.dir(blob);

      // this.data = response.output;
      this.data = atob(response.output);

      // this.pdfSrc = blob;
      // this.pdfSrc = URL.createObjectURL(blob);
      // this.pdfSrc = new Blob([response.output], { type: 'application/pdf' });
      // this.pdfSrc = new Blob([atob(response.output)], { type: 'application/pdf' });;

      // new Response(blob).arrayBuffer()
      //     .then(output => {
      //       this.pdfSrc = new Uint8Array(output);
      //
      //     });

      // if (response.outputContentType && response.outputContentType === 'application/json') {
        // console.log('name: ' + response.output['firstName']);

        // this.model = response.output;
        // this.modelView = JSON.stringify(this.model, null, 3);
        // this.changeDetectorRef.detectChanges();

        // this.onExecuteTemplate();
      // }

    });

  }

  onError($event: any) {
    console.error($event);
  }
}
